export default "__VITE_ASSET__7ffedee2__"